// extracted by mini-css-extract-plugin
module.exports = {"features":"_2-hg8","amenityList":"Jxx_1","amenityItem":"_1V_V5","amenityIcon":"_2PWJh","amenityIconBlue":"_1Q9Us","amenityAmount":"__HLb","propertyType":"_3bmb_"};